import { useSearchParams } from 'react-router-dom';

import { SplitViewPane } from '@/components/SplitViewPane';

import { OptimizationRun } from './OptimizationRun';
import { OptimizationRunsTable } from './OptimizationRunsTable';

export const OptimizationRunsPage = ({ repoName }: { repoName: string }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const jobId = searchParams.get('jobId');

  const handleBack = () => {
    searchParams.delete('jobId');
    setSearchParams(searchParams);
  };

  return (
    <div className="flex flex-col gap-2 py-4">
      <SplitViewPane
        open={!!jobId}
        onClose={handleBack}
        title={'Optimization Run'}
      >
        {jobId && <OptimizationRun repoName={repoName} jobId={jobId} />}
      </SplitViewPane>
      <OptimizationRunsTable repoName={repoName} />
    </div>
  );
};
